import React from 'react'

import { Button } from '@mote/ui'
import { ChromeIcon } from '@mote/assets/icons'
import { CWS_URL } from '@mote/helpers/constants'
import { useTrackMutation } from '@mote/api'
import { useLocalStoragePermission } from '@mote/helpers/browser'

export const AddToChromeButton = () => {
  const { mutate: track } = useTrackMutation()
  const canAccessLocalStorage = useLocalStoragePermission()

  function handleAddToChromeClick() {
    track({
      variables: {
        event: 'Install Extension Clicked',
        referrer_user_id: canAccessLocalStorage
          ? window.localStorage.getItem('mote_referrer_user_id')
          : ''
      }
    })
    window.open(CWS_URL, '_new')
  }

  return (
    <Button
      text='Add to Chrome'
      iconPosition='left'
      icon={<ChromeIcon />}
      onClick={handleAddToChromeClick}
      style={{ text: { fontWeight: 400 } }}
    />
  )
}
